import { request } from '../plugins/http'

const state = {
    error: {
        request:{status:null},
        response: {data:{error:null}}
    },
    success: {
        request:{status:null},
        response: {data:{success:null}}
    },
    dialog: false,
    dialogSuccess: false
}

const getters = {
    error(state) {
        return state.error
    },
    dialog(state) {
        return state.dialog
    },
    success(state) {
        return state.success
    },
    dialogSuccess(state) {
        return state.dialogSuccess
    },
}

const actions = {
    intercept({ commit }) {
        request.interceptors.response.use(success, getError)

        function success(response) {
            if(response.data.success) commit('SHOW_SUCCESS', response)
            return response
        }
        function getError(err) {
            if (err.request.status === 401) localStorage.removeItem('user')
            commit('SHOW_ERROR', err)
            return Promise.reject(err)
        }
    },
    clearError({ commit }) {
        commit('CLEAR_ERROR')
    },
    closeDialog({ commit }) {
        commit('CLOSE_DIALOG')
    },
    clearSuccess({ commit }){
        commit('CLEAR_SUCCESS')
    },
    closeSuccess({ commit }) {
        commit('CLOSE_DIALOG_SUCCESS')
    },
}

const mutations = {
    SHOW_ERROR(state, res) {
        state.dialog = false
        setTimeout(() => {
            state.dialog = true
            state.error = res
        })
    },
    CLEAR_ERROR(state) {
        state.error = {
            request:{status:null},
            response: {data:{error:null}}
        }
    },
    CLOSE_DIALOG(state) {
        state.dialog = false
    },
    SHOW_SUCCESS(state, res) {
        state.dialogSuccess = false
        setTimeout(() => {
            state.dialogSuccess = true
            state.success = res
        })
    },
    CLEAR_SUCCESS(state) {
        state.success = {
            request:{status:null},
            response: {data:{success:null}}
        }
    },
    CLOSE_DIALOG_SUCCESS(state) {
        state.dialogSuccess = false
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
